import { SelectLayout } from '@/components/SelectLayout';
import SquareGrid from '@/components/Util/reactSquareGrid';
import { ReactNode } from 'react';
import { View } from 'react-native';

interface HomeMainProps {
  exerciseSets: unknown;
  rightButtons: ReactNode;
}

export const HomeMain = ({ exerciseSets, rightButtons }: HomeMainProps) => {
  return (
    <View className="flex-1 bg-blue-neolexonlight">
      <SelectLayout
        leftGrid={<SquareGrid items={exerciseSets} rows={2} columns={2} />}
        rightGrid={rightButtons}
      />
    </View>
  );
};
